module.exports = __webpack_public_path__ + "img/penqi3.58433954.jpg";